import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';

import { SocialType } from '@flipster/apis/v1/user/types';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { ClearableNumberInputWithFrame } from '../../../../../../../input/clearable-number-input';
import { socialProviders } from '../../../../../../../shared/social-link';
import { editProfileBunja } from '../../../../bunja';

interface CommunitySizeInputProps {
  type: SocialType;
}

export const CommunitySizeInput = ({ type }: CommunitySizeInputProps) => {
  const { socialForms } = useBunja(editProfileBunja);
  const { formAtom, strippedSocialLinkAtom } = socialForms[type];
  const [form, setForm] = useAtom(formAtom);
  const stripped = useAtomValue(strippedSocialLinkAtom);
  const isCountDisabled = !stripped;
  return (
    <div className={stack({ gap: 8 })}>
      <p
        className={css({
          textStyle: 'Text/M/Regular',
          color: isCountDisabled ? 'content.default.level-1' : 'content.default.level-5',
        })}
      >
        <FormattedMessage id='Autogen_common.r251126.s_Community_size' />
      </p>
      <ClearableNumberInputWithFrame
        disabled={isCountDisabled}
        placeholder={isCountDisabled ? '' : 'Required'}
        precision={0}
        value={isCountDisabled ? '' : (form.count ?? '')}
        onChange={(value) => setForm('count', value)}
        onClearClick={() => setForm('count', '')}
        suffix={
          <p
            className={css({
              textTransform: 'capitalize',
              textStyle: 'Text/M/Regular',
              color: 'content.default.level-2',
            })}
          >
            {socialProviders[type].suffix}
          </p>
        }
        className={css(
          {
            textStyle: 'Text/M/Monospace/Regular',
            color: 'content.default.level-5',
            caretColor: 'content.accent.info',
            '& div': {
              justifyContent: 'space-between',
            },
          },
          isCountDisabled && { borderColor: 'border.default.level-1!' },
        )}
      />
    </div>
  );
};
